import React, { useState } from "react";
import { BootstrapModal } from "../../../BootstrapModal/Modal";
import styled from "styled-components";
import { CgClose } from "react-icons/cg";
import Button from "../../../Button/Button";
import {
  useGetProductList1,
  useUpdatePropertyLevelOne,
} from "../../../../hooks/useContent";
import {
  RefreshTableLevelFirst,
  ContentUnitModal,
} from "../../../../shared/content-unit";
import { useRecoilState } from "recoil";
import {
  RowElement,
  RowLayoutStyle,
} from "../../../ContentUnit/Sliders/AddSlide";
import { InputField1 } from "../../../InputField1/InputField1";
import Spinner from "react-bootstrap/Spinner";
import Typography from "../../../Typography/Typography";
import { errorMessage } from "../../../../utils/message";
import { SelectMulti } from "../../../MultiSelect/MultiSelect";
import { useEffect } from "react";

function EditProperty({ show, handleClose }) {
  const {
    mutateAsync: updateProperty,
    isLoading: reqLoading,
    isError: reqError,
  } = useUpdatePropertyLevelOne();
  const [refreshEffect, setRefreshEffect] = useRecoilState(
    RefreshTableLevelFirst
  );
  const [updateState, setUpdateState] = useRecoilState(ContentUnitModal);

  const selectCategoryFormat =
    updateState.updateProperty?.value?.categories?.map((item) => ({
      label: item?.NameCategories,
      value: item?.IdCategories,
    }));

  const [selectOption, setSelectOption] = useState(selectCategoryFormat);

  const { data: listProduct, isLoading: loadingCategorty } =
    useGetProductList1("");

  const initialListProduct = listProduct?.data?.categories?.map((item) => ({
    label: item?.NameCategories,
    value: item?.IdCategories,
  }));

  const [initialValues, setValueForm] = useState({
    title: updateState.updateProperty.value.TitleProperties
      ? updateState.updateProperty.value?.TitleProperties
      : "",
    label: updateState.updateProperty.value.LableProperties
      ? updateState.updateProperty.value?.LableProperties
      : "",
    en_title: updateState.updateProperty.value.TitlePropertiesEnglish
      ? updateState.updateProperty.value?.TitlePropertiesEnglish
      : "",
    en_label: updateState.updateProperty.value.LablePropertiesEnglish
      ? updateState.updateProperty.value?.LablePropertiesEnglish
      : "",
    ar_title: updateState.updateProperty.value.TitlePropertiesLanguage
      ? updateState.updateProperty.value?.TitlePropertiesLanguage
      : "",
    ar_label: updateState.updateProperty.value.LablePropertiesLanguage
      ? updateState.updateProperty.value?.LablePropertiesLanguage
      : "",
    category_id: selectCategoryFormat.map((cat) => {
      return cat?.value;
    }),
  });

  const handleChange = (e) => {
    const { value, name } = e.target;
    setValueForm({ ...initialValues, [name]: value });
  };

  const validateForm = () => {
    if (initialValues.title.length < 1) {
      errorMessage("لطفا نام فارسی دسته بندی را وارد کنید");
      return false;
    } else if (initialValues.label.length < 1) {
      errorMessage("لطفا لیبل فارسی را وارد کنید");
      return false;
    }
    return true;
  };

  const handleSubmit = () => {
    if (validateForm()) {
      const queryData = {
        ...initialValues,
        property_id: updateState.updateProperty.value?.IdProperties,
      };

      updateProperty(queryData).then((res) => {
        setRefreshEffect(!refreshEffect);
        handleClose();
      });
    }
  };

  useEffect(() => {
    if (updateState) {
      // setValueForm({
      //   ...initialValues,
      //   category_id: updateState?.updateProperty?.value?.categories,
      // });
    }
  }, [updateState]);

  return (
    <BootstrapModal
      show={show}
      handleClose={handleClose}
      modaltitle={"ویرایش ویژگی سطح 1"}
      size="md"
      closebutton={
        <Button style={{ width: "40px", border: "none" }} onclick={handleClose}>
          <CgClose />
        </Button>
      }
    >
      <UpdateCategoryStyle>
        <RowColumn>
          <InputField1
            type="text"
            name="title"
            label="نام فارسی"
            onChange={handleChange}
            value={initialValues?.title}
            placeholder="نام فارسی دسته بندی.."
            maxLenght="50"
          />

          <InputField1
            type="text"
            name="en_title"
            label="نام انگلیسی"
            onChange={handleChange}
            value={initialValues?.en_title}
            placeholder="نام انگلیسی دسته بندی..."
            maxLenght="50"
          />

          <InputField1
            type="text"
            name="ar_title"
            label="نام عربی"
            onChange={handleChange}
            value={initialValues?.ar_title}
            placeholder="نام دسته بندی عربی ..."
            maxLenght="50"
          />
        </RowColumn>
        <RowColumn>
          <InputField1
            type="text"
            name="label"
            label="لیبل"
            onChange={handleChange}
            value={initialValues?.label}
            placeholder="لیبل فارسی"
            maxLenght="50"
          />
          <InputField1
            type="text"
            name="en_label"
            label="لیبل انگلیسی"
            onChange={handleChange}
            value={initialValues?.en_label}
            placeholder="لیبل انگلیسی .."
            maxLenght="50"
          />
          <InputField1
            type="text"
            name="ar_label"
            label="لیبل عربی"
            onChange={handleChange}
            value={initialValues?.ar_label}
            placeholder="لیبل عربی ..."
            maxLenght="50"
          />
          <SelectMulti
            label="دسته بندی محصول"
            // value={initialValues.category_id?.map((item) => ({
            //   label: item?.NameCategories,
            //   value: item?.IdCategories,
            // }))}
            value={selectOption}
            res={initialListProduct}
            onChange={(e) => {
              setValueForm({
                ...initialValues,
                category_id: Array.isArray(e) ? e.map((x) => x.value) : [],
              });
              setSelectOption(e);
            }}
          />
        </RowColumn>
        <Button
          bgColor={"#4c78a9"}
          small={"100px"}
          className="m-r-1"
          onclick={(e) => {
            !reqLoading && handleSubmit();
          }}
          color="#fff"
        >
          {reqLoading ? (
            <Spinner animation="border" size="sm" />
          ) : (
            <Typography size={"15px"} primary={"#fff"}>
              ویرایش
            </Typography>
          )}
        </Button>
        <Button
          className={"mr-2"}
          style={{ marginRight: "10px" }}
          color={"#fff"}
          bgColor={"#f1416c"}
          small={"100px"}
          onclick={handleClose}
        >
          <Typography size={"15px"} primary={"#fff"}>
            انصراف
          </Typography>
        </Button>
      </UpdateCategoryStyle>
    </BootstrapModal>
  );
}

const UpdateCategoryStyle = styled.div``;

const RowColumn = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 1rem;
`;

export default EditProperty;
